<p-table [value]="movements" styleClass="sling-table" autoLayout="true" [lazy]="true">
    <ng-template pTemplate="header">
        <tr>
            <th class="text-center">Sentido</th>
            <th class="text-center">Fila</th>
            <th class="text-center">Prev.</th>
            <th class="text-center">Mov.</th>
            <th class="text-center">Embarcação</th>
            <th class="text-center">Grupo</th>
            <th class="text-center">Objetivo</th>
            <th class="text-center">Modelo</th>
            <th class="text-center">Local Atual</th>
            <th class="text-center">Destino</th>
            <th class="width-operation text-center">Operação</th>
            <th class="width-btn-actions text-center"></th>
            <th class="width-btn-actions text-center"></th>

        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-movement>
        <tr class="border-align-opacity" [ngClass]="{highlighted: isHighlighted(movement)}">
            <td class="text-center">
                <app-movement-arrow-direction *ngIf="movement?.arrowDirection" [darkMode]="false" [arrowDirection]="movement.arrowDirection"></app-movement-arrow-direction>
            </td>
            <td class="text-center">
              <span class="boat-name-width" [pTooltip]="movement.boat.name" tooltipPosition="bottom" >
                {{ movement.scheduleName }}
              </span>
            </td>
            <td  class="text-center">
              <app-movement-expected-date [params]="{ date: movement.date}"></app-movement-expected-date>
            </td>
            <td class="text-center">
              <app-movement-means-icon-url [params]="{ iconUrls: movement?.movementMeanIconUrlList }">
              </app-movement-means-icon-url>
            </td>
            <td class="text-center">
              <span class="boat-name-width" [pTooltip]="movement.boat.name" tooltipPosition="bottom" >
                {{ movement.boat.name }}
              </span>
            </td>
            <td class="text-center">
              <span>{{movement?.movementGroupCode}}</span>
            </td>
            <td class="text-center">
              <span>{{movement?.movement?.objective | translate}}</span>
            </td>
            <td class="text-center">
                {{movement.boat.shipType.toUpperCase() | translate}}&nbsp;
                {{movement.boat.commercialLength}}'
            </td>
            <td class="text-center">
              <app-movement-location
                [params]="getOrigin(movement)"
              >
              </app-movement-location>
            </td>
            <td class="text-center">
              <app-movement-location *ngIf="movement?.movement"
                [params]="getDestiny(movement)">
              </app-movement-location>
            </td>
            <td class="width-operation" [ngClass]="getCssRulesButtonExecution(movement)">
                <button class="button-execution {{getCssRulesButtonExecution(movement)}}" type="button" (click)="executeOperation(movement)">
                    <span style="white-space: nowrap"><i class="icon-operation {{getIcon(movement)}}"></i> {{'MOVEMENT.' + movement.nextOperation | translate}}</span>
                </button>
            </td>
            <td class="width-btn-actions text-center" [ngClass]="getCssRulesButtonExecution(movement)">
                <button type="button" class="fab-button btn-white icon-button spacing"
                        *ngIf="isEnableCancel(movement)"
                        (click)="cancelLastOperation(movement)">
                    <i class="pi pi-replay"></i>
                </button>
                <!--              <button type="button" class="fab-button btn-white icon-button spacing"-->
                <!--                (click)="movementPlainView(movement)"pTooltip="Visualizar documento" tooltipPosition="bottom">-->
                <!--                <i class="pi pi-eye"></i>-->
                <!--              </button>-->
                <!--              <button type="button" class="fab-button btn-white  icon-button"-->
                <!--                (click)="openEditDialog(movement)" pTooltip="Editar" tooltipPosition="bottom">-->
                <!--                <i class="pi pi-pencil"></i>-->
                <!--              </button>-->

            </td>
            <td class="width-btn-actions text-center" [ngClass]="getCssRulesButtonExecution(movement)">
                <button class="fab-button btn-white icon-button" type="button" (click)="setSelectedMovement(movement); tableMenu.toggle($event)">
                    <i class="pi pi-ellipsis-v"></i>
                </button>
                <p-menu #tableMenu [popup]="true" [model]="items" appendTo="body"></p-menu>
            </td>
        </tr>
    </ng-template>
</p-table>
